import React, {useEffect, useState} from "react";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  InputAdornment,
  Link,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
  SvgIcon,
  TextField,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Search as SearchIcon} from 'react-feather';
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import UtilService from "../../../helper/service";
import roles from "../../../helper/roles";
import {
  emptyUserMetrics,
  moveNextPage,
  updateUserAttributes
} from '../../../store/actions/creator/creatorExperienceBuilder';
import {initialUserMetrics} from "../../../store/reducers/creator/creatorExperienceBuilder";
import {
  getCreatorList,
  getCreatorsList,
  onClearSearch,
  onSetChecked,
  onSetSearchText,
  onSetSelected,
  onSetUserDropdown,
  searchExperience,
  updatesearchfilters,
  updateSearchKey,
  updateSearchText,
  updateSearchUsers
} from '../../../store/actions/experience/experience';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {PAGINATION_PER_PAGE_ITEM} from '../../../config/mock';
import Config from "../../../config/config";
import {useDebouncedCallback} from 'use-debounce';
import {SearchLoading} from '../../atoms/commonLoadings';
import {Mixpanel} from "../../../helper/mixpanel";

const useStyles = makeStyles(() => ({
  addNewBtn: {
    fontFamily: 'roboto-regular',
    marginLeft: 5,
    marginRight: 5,
    whiteSpace:'nowrap',
    '@media (max-width: 840px)': {
      display: 'none'
    },
  },
  addNewBtnMobile: {
    display: 'none',
    fontFamily: 'roboto-regular',
    marginLeft: 5,
    marginRight: 5,
    whiteSpace:'nowrap',
    '@media (max-width: 840px)': {
      display: 'block'
    },
  },
  link: {
    color: '#017AEF',
    textDecoration: 'none',
    fontWeight: 600,
    marginTop: 20,
    cursor:'pointer'
  },
  btn: {
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    margin: '0 15px',
  },
  icon: {
    marginRight: -10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  },
  newExperienceDesc:{
    margin: 0, 
    paddingRight:8,
    font: 'normal normal bold 12px/16px Roboto',
    letterSpacing: '-0.18px', 
    color:'#697683',
    '@media (max-width: 959px)': {
      marginBottom:6
    },
  },
  addexpDescription:{
    textAlign: 'right', 
    display: 'table-cell',
    verticalAlign: 'middle',
    '@media (max-width: 599px)': {
      // display:'none',
    },
  },
  addexpbuttonwrapper:{
    textAlign: 'right',
    '@media (min-width: 1280px)': {
      display:'flex',
      justifyContent:'flex-end'
    }
  },
  dftbtn:{
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#fff !important',
    textTransform: 'none',
    fontSize: 14,
    minWidth: '230px',
    '&:hover': {
      background: '#F0F0F0',
    },
    margin: '0 8px',
    '@media (max-width: 959px)': {
      marginBottom:6
    },
  },
  mobileBtn: {
    position: 'absolute',
    right: 5,
    top: 14
  }
}));

function DashboardHeaderSearchBox() {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    searchCleared, searchKey, creatorList, searchSessionPage , sessions, ownerSessionCount, searchText,
    is_search_loading, searchnewText, checked, selected, isUserDropdown
  } = useSelector((state: any) => state.experience);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const search_sort_request= localStorage.getItem("search_sort_request") ? JSON.parse(localStorage.getItem("search_sort_request") || "{}") : "";

  const [Creators, setCreators] = useState<any>([]);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { billingDetails } = useSelector((state: any) => state.adminUser);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [allowAddExp, setAllowaddExp] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  useEffect(() => {
    if (searchCleared) {
      clearSearch()
    }
  }, [searchCleared]);

  useEffect(() => {
    if (!location.pathname.includes('creator/dashboard') && searchKey) {
      clearSearch()
    }
  }, [location.pathname]);

  useEffect(() => {
    dispatch(onSetUserDropdown(false));
  }, []);

  useEffect(() => {
    if(billingDetails && billingDetails.data && billingDetails.data.pay_status){
      if(billingDetails.data.pay_status === 'TRIAL' && ownerSessionCount && parseFloat(ownerSessionCount) >= 5){
        setAllowaddExp(false);
      }
    }

  }, [billingDetails, sessions]);

  const clearSearch = () => {
    dispatch(onSetSearchText(""));
    dispatch(onSetChecked([]));
    dispatch(onSetSelected([]));
    dispatch(onSetUserDropdown(false));
    dispatch(updateSearchKey(''));
    dispatch(updateSearchText(''));
    dispatch(updateSearchUsers([]));
    dispatch(updatesearchfilters('clear'));
    dispatch(getCreatorList(null));
    localStorage.removeItem('search_sort_request');
  };

  const onGoAddNew = () => {
    dispatch(moveNextPage(0));
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    if (!!userData) {
      Mixpanel.identify(userData.user_id);
      Mixpanel.track('mne_button');
      Mixpanel.people.set({
        $email: userData.username,
        $first_name: userData.first_name,
        $last_name: userData.last_name,
        $team: userData.department_name,
        $type: userData.role_alias
      });

      const emptyRequest = {
        temporary_value: initialUserMetrics,
        user_id: userData.user_id,
      };
      dispatch(updateUserAttributes(apolloClient.client, emptyRequest));
      dispatch(emptyUserMetrics());
      let url = `/creator/experience-builder`;
      if (UtilService.checkTrialAccess(userData, roles['trial']['builder'])) {
        url = `/subscriber/creator/experience-builder`;
      }
      history.push(url)
    }
  };

  const onSearchExp = useDebouncedCallback((e) => {
    dispatch(updatesearchfilters('clear'));
    if (e.target && e.target.value === searchnewText && e.target.value.trim() && e.target.value.trim().length >= 3 && Creators.length <= 1) { // there are inserted texts
      const req = {
        keyword: e.target.value.trim(), 
        user_id:[],
        page_no: 1,
        size: PAGINATION_PER_PAGE_ITEM * searchSessionPage,
        clip_page_no: 1,
        clip_page_size: PAGINATION_PER_PAGE_ITEM * searchSessionPage,
        identifier: 'session',
        sort_direction: search_sort_request.sort_direction,
        sort_column: search_sort_request.sort_column
      };
      dispatch(searchExperience(apolloClient.client, req));
      dispatch(updateSearchText(e.target.value.trim()));
      dispatch(updateSearchUsers([]));
      dispatch(onSetUserDropdown(false));
    } else { // empty value in the search box
      if (e.target && e.target.value.trim().length <= 0 && selected.length <= 0) {
        dispatch(updateSearchKey(null));
      }
    }
  }, 1000);
  
  useEffect(() => {
    if (searchnewText.length <= 0 && selected.length <= 0) {
      dispatch(updateSearchKey(null));      
    }
  }, [searchKey]);

  useEffect(() => {
    if (searchnewText && searchnewText.length && searchnewText !== searchText && Creators && Creators.length) {
      dispatch(onSetUserDropdown(true));
    }
    if (searchnewText.length <= 0 && selected.length <= 0) {
      dispatch(updateSearchKey(null));      
    }
  }, [searchnewText]);
  
  const applySearch = () => { // apply search with user selection
    const req = { 
      keyword: searchnewText, 
      user_id: checked,
      page_no: 1, 
      size: PAGINATION_PER_PAGE_ITEM * searchSessionPage,
      clip_page_no: 1,
      clip_page_size: PAGINATION_PER_PAGE_ITEM * searchSessionPage,
      identifier: 'session',
      sort_direction: search_sort_request.sort_direction ? search_sort_request.sort_direction : "",
      sort_column: search_sort_request.sort_column ? search_sort_request.sort_column : "",
    };
    dispatch(onClearSearch(false));
    dispatch(searchExperience(apolloClient.client, req));
    dispatch(updateSearchText(searchnewText));
    dispatch(updateSearchUsers(checked));
    dispatch(updatesearchfilters('clear'));
    dispatch(onSetUserDropdown(false));
  };

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode !== 8) {
      if (Creators && Creators.length <= 1) {
        if (event.keyCode === 13 && searchnewText && searchnewText.trim().length >= 3 || selected.length > 0 || (searchKey)) {
          onSearchExp(event);
        }
      } else if (event.keyCode === 13 && (searchnewText && searchnewText.trim().length >= 3 || selected.length > 0 || (searchKey))) {
        applySearch();
      }  
    }
  };
  
  const onCancel = () => {
    clearSearch();
  };

  const checkformultiUsers = () => {
    dispatch(getCreatorsList(apolloClient.client));
    if (Creators && Creators.length > 1) {
      dispatch(onSetUserDropdown(true));
    }
  };

  useEffect(() => {
    if(creatorList && creatorList.length){
      dispatch(onSetUserDropdown(true));
      setCreators(creatorList);
    }
  }, [creatorList]);

  const handleSelectUser = (e:any, value: any) => {
    e.preventDefault();
    const checkedvalues :any = [];
    if(value && value.length){
      value.map((val:any)=>{
        checkedvalues.push(parseFloat(val.user_id));
      })
    }
    dispatch(onSetChecked(checkedvalues));
    dispatch(onSetSelected(value));
  };

  const redirectToBilling = () => {
    let url = `/admin/billing`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['admin'])) {
      url = `/subscriber/admin/billing`;
    }
    history.push(url)
  };

  const redirectToContactUs = () => {
    window.open(Config.CONTACT_US_URL, '__blank');
  };

  return (
    <div style={{marginTop:10}} className="searchWrapper">
      {isMobile && <div className={classes.mobileBtn}>
        {!allowAddExp ?
          <Button
            color='default'
            id='mne_button'
            className={classes.dftbtn}
            disabled={true}
          >
            <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
            <span className={classes.addNewBtn}>Measure New Experience</span>
            <span className={classes.addNewBtnMobile}>Add New</span>
          </Button>
        :
          <Button
            color='primary'
            className={classes.btn}
            id='mne_button'
            onClick={onGoAddNew}
          >
            <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
            <span className={classes.addNewBtn}>Measure New Experience</span>
            <span className={classes.addNewBtnMobile}>Add New</span>
          </Button>
        }
      </div>}
      
      {!isMobile && <Grid container>
        <Grid item md={12} sm={12} className={classes.addexpbuttonwrapper} >
            {!allowAddExp &&
              <div>
                <p className={classes.newExperienceDesc}>
                  You’ve reached your free trial limit of 5 experiences measured. 
                </p>
                <p className={classes.newExperienceDesc}>
                  To measure a new experience, please 
                  <Link onClick={redirectToBilling} className={classes.link}  target='_blank'> upgrade to a paid plan </Link>
                  or <Link onClick={redirectToContactUs} className={classes.link}  target='_blank'>contact us </Link>
                  for help.
                </p>
              </div>
            }
            {!allowAddExp ?
              <Button
                color='default'
                className={classes.dftbtn}
                disabled={true}
              >
                <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
                <span className={classes.addNewBtn}>Measure New Experience</span>
                <span className={classes.addNewBtnMobile}>Add New</span>
              </Button>
            :
              <Button
                color='primary'
                id='mne_button'
                className={classes.btn}
                onClick={onGoAddNew}
              >
                <img src={'/assets/icons/creatordashboard/plus_icon.svg'} alt={'img'} />
                <span className={classes.addNewBtn}>Measure New Experience</span>
                <span className={classes.addNewBtnMobile}>Add New</span>
              </Button>
            }
            
            
            <TextField
              className="inputRounded"
              size="small"
              variant="outlined"
              style={{ color: '#697683' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon
                      fontSize="small"
                      color="action"
                    >
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                ),
                endAdornment: <InputAdornment position="end">
                  {
                    is_search_loading ? 
                      <SearchLoading />
                    :
                      searchnewText && <img
                        src={'/assets/icons/creatordashboard/remove.svg'}
                        alt={'icon'}
                        className={classes.icon}
                        onClick={() => clearSearch()}
                      />
                  }
                </InputAdornment>
              }}
              value={searchnewText}
              onChange={
                (e) => {
                  dispatch(onSetSearchText(e.target.value));
                  (Creators.length <= 1) && onSearchExp(e);
                }
              }
              onFocus={() => checkformultiUsers()}
            />
        </Grid>
      </Grid>}

      {(isUserDropdown && Creators.length > 1) && !isMobile &&
        <>
          <div className="creatorlistBackground" onClick={()=>dispatch(onSetUserDropdown(false))}></div>
          <div className="Creators_list">
          <Paper elevation={10} className="creator_list_paper"  variant="outlined" >
              <Autocomplete
                multiple
                id="creator-users-autocomplete"
                options={Creators}
                value={selected}
                disableCloseOnSelect
                onChange={(e:any, selected:any) => handleSelectUser(e, selected)}
                getOptionLabel={(option: any) => (option.first_name && option.last_name) ? option.first_name+ " " + option.last_name : option.username}
                renderOption={(option: any) => (
                  <React.Fragment>
                     <ListItem key={option.user_id} role={undefined} dense button className="creatorlistItem">
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={checked.indexOf(parseFloat(option.user_id)) !== -1}
                      />
                      <ListItemText className="creatorListText"  primary={(option.first_name && option.last_name) && option.first_name+ " " + option.last_name} secondary={option.username} />
                    </ListItem>
                  </React.Fragment>
                )}
                style={{ width: '100%', fontSize:"12px" }}
                renderInput={(params) => (
                  <TextField {...params} variant="standard" label="Select Creators" placeholder="" />
                )}
              />
            <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
              <Button onClick={onCancel} variant="contained" size='small' className={classes.modalBtn}>
                Cancel
              </Button>
              <Button onClick={applySearch}
                disabled = {((searchnewText && searchnewText.trim().length >= 3) || selected.length > 0 || (searchKey)) ? false : true}
                variant="contained" color='primary' size='small' className={classes.modalBtn}>
                Apply
              </Button>
            </Box>
          </Paper>
        </div>
        </>
      }
    </div>
  )
}

export default DashboardHeaderSearchBox;